import {createApp, h} from 'vue';
import {createPinia} from 'pinia';
import * as Sentry from "@sentry/vue";

import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice'
import DialogService from 'primevue/dialogservice'
import Safari from "@/AdminApp/Preset/Safari.ts";
import '../bootstrap';
import App from '@/AdminApp/App.vue';
import router from "./router";
import {VueReCaptcha} from "vue-recaptcha-v3";
import Ripple from 'primevue/ripple';
import ToastService from 'primevue/toastservice';
import {emitter} from "@/AdminApp/Utils/emitter.ts";

const env = import.meta.env;
const app = createApp({
	render: () => h(App),
	data() {
		return {}
	},
	mounted() {
		this.$primevue.config.ripple = true;
	}
});
app.use(PrimeVue, {
	theme: {
		preset: Safari,
		options: {
			darkModeSelector: 'none',
		}
	},
	locale: {
		startsWith: 'Kezdődik ezzel',
		contains: 'Tartalmazza',
		notContains: 'Nem tartalmazza',
		endsWith: 'Végződik ezzel',
		equals: 'Egyenlő',
		notEquals: 'Nem egyenlő',
		noFilter: 'Nincs szűrő',
		filter: 'Szűrés',
		lt: 'Kisebb, mint',
		lte: 'Kisebb vagy egyenlő',
		gt: 'Nagyobb, mint',
		gte: 'Nagyobb vagy egyenlő',
		dateIs: 'A dátum',
		dateIsNot: 'Nem ez a dátum',
		dateBefore: 'Dátum előtte',
		dateAfter: 'Dátum utána',
		clear: 'Törlés',
		apply: 'Alkalmaz',
		matchAll: 'Mind megfelel',
		matchAny: 'Bármelyik megfelel',
		addRule: 'Szabály hozzáadása',
		removeRule: 'Szabály törlése',
		accept: 'Igen',
		reject: 'Nem',
		// Dátum formázás (ha naptár is van)
		dayNames: ["Vasárnap", "Hétfő", "Kedd", "Szerda", "Csütörtök", "Péntek", "Szombat"],
		dayNamesShort: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
		dayNamesMin: ["V", "H", "K", "Sz", "Cs", "P", "Sz"],
		monthNames: ["Január", "Február", "Március", "Április", "Május", "Június", "Július", "Augusztus", "Szeptember", "Október", "November", "December"],
		monthNamesShort: ["Jan", "Feb", "Már", "Ápr", "Máj", "Jún", "Júl", "Aug", "Szep", "Okt", "Nov", "Dec"],
		today: 'Ma',
		weekHeader: 'Hét',
		firstDayOfWeek: 1
	}
});

app.use(createPinia());
app.use(router);
app.use(ConfirmationService);
app.use(DialogService);
app.use(ToastService);
//@ts-ignore
app.use(VueReCaptcha, {siteKey: env.VITE_RECAPTCHAV3_SITEKEY});
app.directive('ripple', Ripple);


app.provide('emitter', emitter);

if (env.VITE_MIX === 'production') {
	Sentry.init({
		app: app,
		dsn: env.VITE_SENTRY_DSN_PUBLIC,
		integrations: [
			Sentry.browserTracingIntegration({router}),
		],
		tracePropagationTargets: ["localhost", env.VITE_MAIN_DOMAIN, env.VITE_ADMIN_DOMAIN, /^\//],
		tracesSampleRate: 1.0,
	});
	app.mixin(Sentry.createTracingMixins({hooks: [], timeout: 0, trackComponents: true}));
	Sentry.attachErrorHandler(app, {attachErrorHandler: true, attachProps: true});
}

app.mount('#app');

